import * as React from 'react'
import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import SelectieButtonEnum from 'shared/components/SelectieButtonEnum'
import { Loader } from 'shared/components/Loader'
import { IApplicationState } from 'redux/store/store'
import {
  vestigingen,
  VestigingEnum,
  exceloptions,
  KoppelingType,
} from 'shared/models/Enum'
import {
  IGetDataResponseAction,
  getDataActionCreator,
  clearDataActionCreator,
  IClearDataResponseAction,
  setWarehouseActionCreator,
  ISetWarehouseAction,
} from 'redux/store/actions/koppelingenVestigingenAction'
import { ExportToCsv } from 'export-to-csv-fix-source-map'
import 'react-day-picker/lib/style.css'
import 'moment/locale/nl'
import { Redirect } from 'react-router'
import { IKlant } from 'shared/models/IKlant'
import { formatDate } from 'shared/service/helpers/DateUtilities'
import { IAfleverafspraakLocatieKoppeling } from 'shared/models/IAfleverafspraakLocatieKoppeling'
import { getDaysDisplay } from 'shared/service/helpers/DateUtilities'
import { getOrderTypesDisplay } from 'shared/service/helpers/OrdertypeUtilities'
import { useEffect } from 'react'
import { IOrderType } from 'shared/models/IOrderType'
import {
  getPossibleOrderTypesActionCreator,
  ISetPossibleOrderTypesResponseAction,
} from 'redux/store/actions/globalAction'

interface IProps {
  requestData: (selectie: VestigingEnum) => Promise<IGetDataResponseAction>
  clearData: (message: string) => Promise<IClearDataResponseAction>
  setWarehouse: (warehouse: VestigingEnum) => Promise<ISetWarehouseAction>
  getPossibleOrderTypes: () => Promise<ISetPossibleOrderTypesResponseAction>
  vestiging: VestigingEnum
  koppelingen: IKlant[]
  schermloading: boolean
  foutmelding: string
  possibleOrderTypes: IOrderType[]
  loadingPossibleOrderTypes: boolean
}

const KoppelingenVestigingenLijst: React.FunctionComponent<IProps> = ({
  requestData,
  clearData,
  setWarehouse,
  getPossibleOrderTypes,
  vestiging,
  koppelingen,
  schermloading,
  foutmelding,
  possibleOrderTypes,
  loadingPossibleOrderTypes,
}) => {
  useEffect(() => {
    getPossibleOrderTypes()
  }, [getPossibleOrderTypes])

  const setVestiging = x => {
    setWarehouse(x)
    clearData(null)
  }

  const zoekKoppelingen = () => {
    console.log('zoekkoppelingen request')
    if (vestiging !== undefined && vestiging !== 0) {
      requestData(vestiging)
    } else {
      clearData('Kies eerst een (geldige) vestiging!')
    }
  }

  const mapToKoppelingen = (
    data: IKlant[]
  ): IAfleverafspraakLocatieKoppeling[] => {
    const agreements = data.reduce((total, customer) => {
      return total.concat(
        customer.klantAfleverafspraken.map(a => {
          return {
            ...a,
            klant: customer,
          }
        })
      )
    }, [])
    const links = agreements.reduce((total, agreement) => {
      return total.concat(
        agreement.afleverafspraakLocatieKoppelingen.map(l => {
          return {
            ...l,
            klantAfleverafspraak: agreement,
          }
        })
      )
    }, [])

    return links
  }

  const exportToCsv = () => {
    const csvExporter = new ExportToCsv(exceloptions)
    csvExporter.generateCsv(
      mapToKoppelingen(koppelingen).map(l => {
        return {
          Klantnummer: l.klantAfleverafspraak.klant.klantNummer,
          Klantnaam: l.klantAfleverafspraak.klant.klantNaam,
          KlantEanCode: l.klantAfleverafspraak.klant.klantEanCode,
          Afleverafspraakreferentie:
            l.klantAfleverafspraak.afleverafspraakReferentie,
          Afleverafspraaknaam: l.klantAfleverafspraak.naam,
          LocatieGlnCode: l.shipToLocationGln.locatieGlnCode,
          LocatieNaam: l.shipToLocationGln.locatieGlnNaam,
          LocatieOmschrijving: l.shipToLocationGln.locatieGlnOmschrijving,
          Ingangsdatum: formatDate(l.ingangsDatumtijd),
          Einddatum: formatDate(l.eindDatumtijd),
        }
      })
    )
  }

  const checkOrderTypesDisplay = (
    klantOrderTypes: string,
    possibleOrderTypes: IOrderType[]
  ): string => {
    let result = ''
    if (klantOrderTypes != null) {
      result = getOrderTypesDisplay(klantOrderTypes, possibleOrderTypes)
    }
    return result
  }

  const checkDaysDisplay = (data: string): string => {
    let result = ''
    if (data != null) {
      result = getDaysDisplay(data)
    }
    return result
  }

  const renderRows = (data: IKlant[]) => {
    return data.map(x => {
      return x.klantAfleverafspraken.map(y => {
        return y.afleverafspraakLocatieKoppelingen.map(z => {
          return (
            <tr key={z.afleverafspraakLocatieKoppelingId}>
              <td>{x.klantNummer}</td>
              <td className='mw-200 overflow-hidden' title={x.klantNaam}>
                {x.klantNaam}
              </td>
              <td>{x.klantEanCode}</td>
              <td>{y.afleverafspraakReferentie}</td>
              <td>{y.naam}</td>
              <td>{KoppelingType[z.koppelingType]}</td>
              <td>
                {checkOrderTypesDisplay(z.orderTypes, possibleOrderTypes)}
              </td>
              <td>{checkDaysDisplay(z.dagen)}</td>
              <td>{z.shipToLocationGln.locatieGlnCode}</td>
              <td
                className='mw-200 overflow-hidden'
                title={z.shipToLocationGln.locatieGlnNaam}
              >
                {z.shipToLocationGln.locatieGlnNaam}
              </td>
              <td
                className='mw-200 overflow-hidden'
                title={z.shipToLocationGln.locatieGlnOmschrijving}
              >
                {z.shipToLocationGln.locatieGlnOmschrijving}
              </td>
              <td>{formatDate(z.ingangsDatumtijd)}</td>
              <td>{formatDate(z.eindDatumtijd)}</td>
            </tr>
          )
        })
      })
    })
  }

  return (
    <div>
      {vestiging === 0 && <Redirect to='/home' />}
      <h2>Gekoppelde Adressen per Vestiging</h2>

      <div>
        {(schermloading || loadingPossibleOrderTypes) && (
          <div>
            <Loader show={true} />
          </div>
        )}
        <table className='selectie'>
          <thead>
            <tr>
              <th className='selectie-label'>Vestiging:</th>
              <th className='selectie-label'></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <SelectieButtonEnum
                  type={VestigingEnum}
                  options={vestigingen}
                  selected={vestiging}
                  onChange={e => setVestiging(e.target.value)}
                />{' '}
              </td>
              <td>
                <div className='row no-gutters'>
                  <div className='col'></div>
                  <div className='col-auto'>
                    <button
                      className='btn btn-primary'
                      onClick={zoekKoppelingen}
                    >
                      Zoek gekoppelde adressen
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {!!foutmelding && (
        <div className='alert alert-danger maxedbox'>{foutmelding}</div>
      )}
      {Array.isArray(koppelingen) && koppelingen.length > 0 && (
        <div>
          <table className='selectie'>
            <thead>
              <tr>
                <th colSpan={10} className='selectie-label'>
                  <div className='row'>
                    <div className='col-auto'>Koppelingen</div>
                    <div className='col-auto'>
                      <button className='btn btn-info' onClick={exportToCsv}>
                        Excel
                      </button>
                    </div>
                    <div className='col'></div>
                  </div>
                </th>
              </tr>
              <tr>
                <th colSpan={10}>
                  <hr />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className='tablesubheader'>
                <td>Klantnr.</td>
                <td>Klantnaam</td>
                <td>Klant EAN</td>
                <td>Afleverafspraakref.</td>
                <td>Afleverafspraaknaam</td>
                <td>Type</td>
                <td>Ordertype</td>
                <td>Dagen</td>
                <td>Locatie GLN</td>
                <td>Locatie naam</td>
                <td>Locatie omschrijving</td>
                <td>Ingangsdatum</td>
                <td>Einddatum</td>
              </tr>
              {renderRows(koppelingen)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    schermloading: store.koppelingenVestigingenState.loading,
    vestiging: store.koppelingenVestigingenState.vestiging,
    koppelingen: store.koppelingenVestigingenState.koppelingen,
    foutmelding: store.koppelingenVestigingenState.foutmelding,
    possibleOrderTypes: store.globalState.possibleGroupLinkOrderTypes,
    loadingPossibleOrderTypes: store.globalState.loadingOrderTypes,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    requestData: (selectie: VestigingEnum) =>
      dispatch(getDataActionCreator(selectie)),
    clearData: (message: string) => dispatch(clearDataActionCreator(message)),
    setWarehouse: (warehouse: VestigingEnum) =>
      dispatch(setWarehouseActionCreator(warehouse)),
    getPossibleOrderTypes: () => dispatch(getPossibleOrderTypesActionCreator()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KoppelingenVestigingenLijst)
